var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadConvo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 10.4167V5.66667C14.6663 4.26654 14.6663 3.56647 14.3939 3.0317C14.1542 2.56129 13.7717 2.17884 13.3013 1.93916C12.7665 1.66667 12.0665 1.66667 10.6663 1.66667H5.33301C3.93288 1.66667 3.23281 1.66667 2.69803 1.93916C2.22763 2.17884 1.84517 2.56129 1.60549 3.0317C1.33301 3.56647 1.33301 4.26654 1.33301 5.66667V14.3333C1.33301 15.7335 1.33301 16.4335 1.60549 16.9683C1.84517 17.4387 2.22763 17.8212 2.69803 18.0609C3.23281 18.3333 3.93284 18.3333 5.33289 18.3333H8.41634M9.66634 9.16667H4.66634M6.33301 12.5H4.66634M11.333 5.83334H4.66634M10.4997 15.8333L12.9997 18.3333M12.9997 18.3333L15.4997 15.8333M12.9997 18.3333V13.3333",
    stroke: "#535862",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadConvo);
export default __webpack_public_path__ + "static/media/download-convo.11af409c28264b64b099d26619630483.svg";
export { ForwardRef as ReactComponent };